<template>
  <div>
    <modal-template ref="modal" modal-size="xl">
      <template v-slot:title>
        {{ lang.modals.or.contact_headline }}
      </template>

      <template v-slot:default>
        <p class="">{{ lang.modals.or.contact_description }}</p>
        <div class="errorMsg alert alert-danger hidden" role="alert"></div>

        <input-textarea
          :label="lang.labels.message"
          name="msg"
          :disabled="disableForm"
          required
          v-model="msg"
        ></input-textarea>
        <div class="text-sm">{{ lang.msg.email_will_be_added_to_msg }}</div>
      </template>

      <template v-slot:footer="footerSlotProps">
        <div
          class="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-4"
        >
          <plain-button
            color="default"
            :disabled="disableForm"
            @click="hideModal()"
          >
            {{ lang.labels.cancel }}
          </plain-button>

          <plain-button
            color="primary"
            :disabled="disableForm || !msg.trim()"
            @click="sendMsg"
          >
            <span v-if="!showConfirmation">{{ lang.labels.send }}</span>
            <span v-else><i class="fas fa-check"></i></span>
          </plain-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import FormErrors from "./../../FormErrors.js";
import ModalTemplate from "./ModalTemplate.vue";

// Props
const props = defineProps({
  lang: Object,
  modalData: Object,
});

// Emits
const emit = defineEmits(['hide-modal', 'msg-sent']);

// Template refs
const modal = ref(null);

// Reactive state
const disableForm = ref(false);
const msg = ref("");
const showConfirmation = ref(false); // true once msg has been sent
const shakeOnError = ref(true);
const formErrors = ref(new FormErrors());

/**
 * init method
 */
const init = () => {};

/**
 * validate input form
 * @return bool
 */
const validateForm = () => {
  formErrors.value.clear();
  shakeOnError.value = true;
  let errors = {};

  // msg
  if (msg.value == "" || msg.value == null) errors.msg = "missing";

  formErrors.value.record(errors);

  if (formErrors.value.any()) {
    setTimeout(() => {
      shakeOnError.value = false;
    }, 500);

    return false;
  }

  return true;
};

/**
 * send msg
 */
const sendMsg = () => {
  disableForm.value = true;
  let validation = validateForm();

  if (validation) {
    axios
      .post(
        `/web-api/offer-request/${props.modalData.offerRequest.id}/msg`,
        {
          msg: msg.value,
        }
      )
      .then((response) => {
        showConfirmation.value = true;
        emit("msg-sent");

        setTimeout(() => {
          emit("hide-modal");
        }, 1000);
      })
      .catch((error) => {
        // console.log(error)
      });
  } else {
    disableForm.value = false;
  }
};

const showModal = () => {
  modal.value.showModal();
  init();
  // writeLogs();
};

const hideModal = () => {
  modal.value.hideModal();
};

// Expose methods for parent components
defineExpose({
  showModal,
  hideModal,
});
</script>

<style scoped>
/* Scoped Styles */
</style>
